import { classNames } from "primereact/utils";

import { useFormFieldContext } from "../form-field.context";
import styles from "../form-field.module.scss";
import type { FormFieldHelpProps } from "../types-form-field";

export function FormFieldHelp({ className, ...rest }: FormFieldHelpProps) {
  const { help, helpId, partTestId, classNames: parts } = useFormFieldContext();

  return help ? (
    <p
      className={classNames(styles.help, parts.help, className)}
      data-testid={partTestId("help")}
      {...rest}
      id={helpId}
    >
      {help}
    </p>
  ) : null;
}
FormFieldHelp.displayName = "FormField.Help";
